<template>
  <div>
    <div>Sorry you got a wrong answer, please try again</div>
    <router-link :to="{name:'Home'}">Try Again</router-link>
  </div>
</template>

<script>
export default {
  setup() {},
};
</script>